import { baseReducerState, BaseReducerState } from "Store/Shared/Store/PropTypes";

export type BusinessUnitId = string;

export interface BusinessUnitState extends BaseReducerState<BusinessUnitId> {
    unsaved: {},
    saved: {},
    new: '',

    createFlowId: string | null
}

export const initialBusinessUnitState: BusinessUnitState = {
    ...baseReducerState,
    unsaved: {},
    saved: {},
    new: '',

    createFlowId: null
}